export default __webpack_public_path__ + "static/media/logo_trans.3ab895d7.png";